
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "./baseApiClient";
import { logger } from "@/lib/logger";

export interface BotActivity {
  id: string;
  ai_staff_id: string;
  activity_type: string;
  description: string;
  metadata: Record<string, any>;
  created_at: string;
}

export const activityApiClient = {
  fetchActivities: async (aiStaffId?: string, limit: number = 10) => {
    const cacheKey = `activities:${aiStaffId || 'all'}:${limit}`;
    
    return BaseApiClient.request<BotActivity[]>(
      cacheKey,
      async () => {
        try {
          let query = supabase
            .from('bot_activities')
            .select('*')
            .order('created_at', { ascending: false })
            .limit(limit);
          
          if (aiStaffId) {
            query = query.eq('ai_staff_id', aiStaffId);
          }
          
          const { data, error } = await query;
          
          if (error) {
            logger.error({
              message: "Error fetching bot activities",
              error,
              context: { aiStaffId, limit }
            });
            throw new Error(`Failed to fetch activities: ${error.message}`);
          }
          
          return data as BotActivity[];
        } catch (error) {
          logger.error({
            message: "Exception fetching bot activities",
            error: error instanceof Error ? error : new Error(String(error)),
            context: { aiStaffId, limit }
          });
          throw error;
        }
      },
      { cache: { enabled: true, duration: 15000 } } // 15 seconds for activities since they change more frequently
    );
  },
  
  clearCache: () => {
    BaseApiClient.clearCache('activities:');
  }
};
